import $ from 'jquery';
import { FILES_TABLE_SELECTOR } from './selectors';

/**
 * Redraws the jQuery/DataTables files table so a newly created file appears without a full page reload.
 * No-op when the table isn't on the page (e.g. the vendor order page, which redirects on submit).
 */

export const refreshLegacyFilesTable = () => {
    if (!$(FILES_TABLE_SELECTOR).length) {
        return;
    }
    $(FILES_TABLE_SELECTOR).DataTable().draw(false);
};
